import { Component } from '@angular/core';

import { SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { TwitterPixelService } from '../../services/twitter-pixel/twitter-pixel.service';
import { isElectron } from '../../utils/platform.utils';
import AppLauncherElectron from 'src/app/plugins/app-launcher.plugin';

@Component({
    selector: 'app-kyc-required-dialog',
    templateUrl: './kyc-required-dialog.component.html',
    styleUrls: ['./kyc-required-dialog.component.scss'],
    standalone: false
})
export class KYCRequiredDialogComponent {
    constructor(
        private sopoDialogRef: SopoDialogRef,
        private twitterPixelService: TwitterPixelService,
    ) { }

    openLink(link: string): void {
        this.twitterPixelService.appDownloadClicked();
        if (isElectron()) AppLauncherElectron.openUrl({ url: link });
        else window.open(link, '_blank');
    }

    close(): void {
        this.sopoDialogRef.close();
    }
}
